import classNames from "classnames";
import React, {PropsWithChildren, ReactNode} from "react";
import {SVVConditionalWrapper} from "@komponentkassen/svv-layout";
import { SVVPopover } from "./Popover";

type LabelProps = PropsWithChildren<{
  className?: string;
  htmlFor?: string;
  id?: string;
  required?: boolean;
  popoverText?: string;
  popoverTitle?: string;
}>;

export function SVVLabel({
  children,
  className,
  htmlFor,
  id,
  required,
  popoverText,
  popoverTitle,
}: LabelProps) {
  return (
    <SVVConditionalWrapper
        condition={!!(popoverText && popoverTitle)}
        // eslint-disable-next-line  @typescript-eslint/no-shadow
        renderWrapper={(children: ReactNode) => (
          <div>{children}</div>
        )}
      >
        <label
          className={classNames("svv-form-label", className, {
            "svv-form-label--inline": popoverText,
          })}
          htmlFor={htmlFor}
          id={id}
        >
          {children} {required && <span aria-hidden="true"> *</span>}
        </label>
        {popoverTitle && popoverText && (
          <SVVPopover title={popoverTitle} explanationText={popoverText} />
        )}
      </SVVConditionalWrapper>
  );
}
